<template>
    <v-flex xs12 class="white">
        <v-tabs next-icon="mdi-arrow-right-bold-box-outline" icons-text prev-icon="mdi-arrow-left-bold-box-outline" show-arrows="show-arrows">
            <v-tabs-slider color="blue-grey darken-3"></v-tabs-slider>
            <v-tab ripple ><v-icon class="v-icon icon-home material-icons mr-2">assignment_ind </v-icon> Empresas</v-tab>
            <v-tab ripple ><v-icon class="v-icon icon-home material-icons mr-2">insert_chart </v-icon> Relatórios</v-tab>

            <v-tab-item>
                <Empresas />
            </v-tab-item>
            <v-tab-item>
                <Relatorios />
            </v-tab-item>
        </v-tabs>
    </v-flex>
</template>

<script>
import Empresas from './Empresas'
import Relatorios from './Relatorios'

export default {
    components: {
        Empresas,
        Relatorios
    }
}
</script>



// WEBPACK FOOTER //
// src/components/root/QueroTaxi/index.vue